import { useState, useEffect } from "react";

export const useLanguageSelection = () => {
  const [showLanguageModal, setShowLanguageModal] = useState(false);

  useEffect(() => {
    // Check if user has already selected a language
    const hasSelectedLanguage = localStorage.getItem(
      "apcg2026-language-selected"
    );

    if (!hasSelectedLanguage) {
      // Show language selection modal after a short delay
      const timer = setTimeout(() => {
        setShowLanguageModal(true);
      }, 1000); // 1 second delay to let the page load

      return () => clearTimeout(timer);
    }
  }, []);

  const handleLanguageSelect = () => {
    setShowLanguageModal(false);
  };

  return {
    showLanguageModal,
    handleLanguageSelect,
  };
};
